export default __webpack_public_path__ + "static/media/whole-bean.77b1c1b9.webp";